import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

declare var dataLayer;
@Directive({
    selector: '[appDebounceClickEvent]',
    standalone: false
})
export class DebounceClickEventDirective implements OnInit, OnDestroy {
  @Input() debounceTime = 0;
  @Output() debounceClick = new EventEmitter();
  private clicks = new Subject();
  private subscription: Subscription;
  constructor() { }

  ngOnInit() {
    this.subscription = this.clicks.pipe(
      debounceTime(this.debounceTime),

    ).subscribe((e: any) => {

      this.debounceClick.emit(e)
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }


  @HostListener('click', ['$event'])
  clickEvent(e) {
    let target = e.target.id && e.target.title ? e.target : e.currentTarget;
    let title = target.title;
    let categoy = target.id.split("_")[0] ? target.id.split("_")[0] : '';
    let idAttr = target.id.split("_")[1] ? target.id.split("_")[1] : '';
    let event = target.dataset.event;

    let temp = target.id.split("_")[2] ? target.id.split("_")[2] : '';
    if (temp) {
      if (target.id.split("_")[2].split(":").length>0) {
        let namePropiedad = target.id.split("_")[2].split(":")[0] ? target.id.split("_")[2].split(":")[0] : '';
        let value = target.id.split("_")[2].split(":")[1] ? target.id.split("_")[2].split(":")[1] : '';
        dataLayer.push({ 'event': event, 'category': categoy, 'action': idAttr, 'label': title, [namePropiedad]: value });

      }else {
        let value = target.id.split(":")[0] ? target.id.split(":")[0] : '';
        dataLayer.push({ 'event': event, 'category': categoy, 'action': idAttr, 'label': title, 'value': value });
      }

    } else {
      dataLayer.push({ 'event': event, 'category': categoy, 'action': idAttr, 'label': title });
    }
  }

}
